<template>
    <div :class="['page', language === 'cn' ? 'font-cn' : 'font-en']">
      <!-- Content Section and Navigation Together -->
      <div class="content-wrapper">
        <!-- Content Section -->
        <div class="content-section">
          <div v-for="(item, index) in content.Items" :key="index" class="content-item">
            <div class="card">  
              <div class="card-body">
                <h1 class="title">{{ item.title }}</h1>
                <div v-html="formattedDescription(item.description_1)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_1" alt="Content Image" class="image" />
                </div>  
                <div v-html="formattedDescription(item.description_2)" class="description"></div>
                <div v-html="formattedDescription(item.description_3)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_2" alt="Content Image" class="image" />
                </div>
                <div v-html="formattedDescription(item.description_4)" class="description"></div>  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </template>
  
  <style src="@/assets/css/news.css" scoped></style>
  
  <script>
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        cn: {
          Items: [
            {
              id: 1,
              image_1: require("@/assets/img/News/011/OrcabeatFrontdoor.jpg"),
              image_2: require("@/assets/img/News/011/OrcabeatTourists.jpg"),
              title: "十一金秋，奥乐奇境VR乐园正式开园",
              description_1:`
               2024年国庆当天，奥乐奇境VR乐园盛大开园，为中国的游客们带来了适合家庭、亲子互动的沉浸式VR娱乐新体验。此乐园由匈牙利的VR Vidámpark团队联合本土合作伙伴云翰虹章、宁波方特和赛创未来倾力打造，实现了文化旅游与先进VR科技的创新融合。
              `,
              description_2:`
              VR Vidámpark团队作为欧洲VR主题公园的先锋，已在欧洲市场取得卓越成就，创建了中欧最大的VR主题乐园之一。 此次进军中国市场，得益于云翰虹章团队的全面支持，确保了其在中国的顺利落地。云翰虹章团队提供了全方位的本地化服务，包括售后管理、用户反馈收集、数据埋点分析等，帮助VR Vidámpark团队克服了进入中国市场的文化与制度差异，顺利适应本地需求。
              `,
              description_3:`奥乐奇境VR乐园开园后，吸引了大量亲子和家庭游客，成为国庆期间的热门娱乐选择。乐园的项目以其高度互动性和沉浸感，为中外家庭游客带来了无与伦比的文化体验，同时也促进了东西方在科技与文化旅游领域的深度交流。开园期间票房表现强劲，显示出市场对高质量、创新型VR娱乐的强烈需求与认可。
              
              `,
              description_4:`
              未来，云翰虹章将与VR Vidámpark团队不断深化合作，拓展VR技术在中国文化旅游中的应用，为游客们带来更多沉浸式体验，促进中西文化与科技的融合与交流。`
            },
            // Add more items as needed
          ],
        },
        en: {
          Items: [
            {
              id: 2,
              image_1: require("@/assets/img/News/011/OrcabeatFrontdoor.jpg"),
              image_2: require("@/assets/img/News/011/OrcabeatTourists.jpg"),
              title: "Orcabeat VR Park Hot Opens in Autumn",
              description_1:`
              On National Day 2024, the grand opening of Orcabeat VR Park brought a new experience of immersive VR entertainment for families, parents and children to Chinese visitors. The park was developed by the Hungarian VR Vidámpark team in collaboration with local partners Rosy Nebula, Ningbo Fantasia and SAICHUANGWEILAI, realising an innovative fusion of cultural tourism and advanced VR technology.
              `,
              description_2:`
              The VR Vidámpark team, a pioneer of VR theme parks in Europe, has already achieved outstanding success in the European market, creating one of the largest VR theme parks in Central Europe. This entry into the Chinese market was made possible by the full support of the Rosy Nebula team, which ensured its smooth landing in China.

              The Rosy Nebula team provided a full range of localisation services, including after-sales management, user feedback collection, data burial point analysis, etc., which helped the VR Vidámpark team overcome the cultural and institutional differences of entering the Chinese market, and smoothly adapt to the local needs.
              `,
              description_3:`The opening of Orcabeat VR Park has attracted a large number of parent-child and family visitors, making it a popular entertainment choice during the National Day. The park's programmes, with their high degree of interactivity and immersion, brought an unparalleled cultural experience to Chinese and foreign family visitors. The strong box office performance during the opening of the park demonstrated the strong demand and recognition of the market for high-quality and innovative VR entertainment.
              
              `,
              description_4:`
              In the future, Rosy Nebula will continue to deepen its cooperation with the VR Vidámpark team to expand the application of VR technology in China's cultural tourism, to bring more immersive experiences to tourists, and to promote the fusion and exchange of Chinese and Western cultures and technologies.`
            },
            // Add more items as needed
          ],
        },
      };
    },
    methods: {
      formattedDescription(description) {
        // Apply additional formatting if needed
        return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
      },
      formattedDescriptionNo(description_no) {
        // Apply additional formatting if needed
        return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
      },
    },
    mixins: [],
    computed: {
      ...mapState(["language"]),
      content() {
        const defaultContent = { title: "", industry_areas: [] };
        const currentLanguage = this.language === "en" ? this.en : this.cn;
        console.log("Current Language:", currentLanguage); // Debug statement
        return currentLanguage || defaultContent;
      },
    },
    watch: {
      language(newValue) {
        console.log("Language changed to:", newValue); // Debug statement
        this.$forceUpdate(); // Force the component to re-render when the language changes
      },
    },
  };
  </script>
